import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as shortlistActions from '../../actions/shortlist';
import mqBreakpoints from 'rp-mq-breakpoints';
import Tabs from '../../components/Catalogue/Tabs';
import Tab from '../../components/Catalogue/Tab';
import LotsFound from './LotsFound';
import SaleFilters from './SaleFiltersShortlist';
import HorseFilters from './HorseFiltersShortlist';
import PedigreeFilters from './PedigreeFiltersShortlist';
import VendorBuyerFilters from './VendorBuyerFiltersShortlist';
import {
    isCommonFiltersTabDisabled,
    isHorseFiltersTabDisabled
} from '../../helpers/catalogueUtils';
import {
    shortlistStateKey,
    isFilteringEmpty
} from '../../helpers/shortlistUtils';
import FiltersLabel from './FiltersLabel';

class ShortlistRefinement extends PureComponent {
    static propTypes = {
        refinement: PropTypes.object.isRequired,
        data: PropTypes.object.isRequired,
        applyDefaultShortlistRefinement: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            activeTabIndex: 0,
            active: false,
            bpCode: mqBreakpoints.current().code
        };

        this.toggle = this.toggle.bind(this);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
    }

    componentWillUnmount() {
        window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
    }

    handleBreakpointChange(e) {
        this.setState({
            bpCode: e.detail.breakpoint.code,
        });
    }

    toggle() {
        this.setState({
            active: !this.state.active
        });
    }

    handleTabChange(activeTabIndex) {
        this.setState({ activeTabIndex });
    }

    isCommonFiltersTabDisabled() {
        return isCommonFiltersTabDisabled(this.props.refinement);
    }

    renderRefinementSwitcher() {
        return (
            <div className="sales__catalogueRefineBtnWrp">
                <button
                    className="ui-btn ui-btn_tiertiary sales__catalogueRefineBtn"
                    onClick={this.toggle}
                >
                    <span>
                        {this.state.active ? 'Close' : 'Refine My Shortlist'}
                    </span>
                </button>
            </div>
        );
    }

    renderVendorBuyerTabTitle() {
        return (
            <span>
                <span className="hidden-sm-down">Vendor / Buyer</span>
                <span className="hidden-xs-down hidden-md-up">Ven / Buy</span>
                <span className="hidden-sm-up">V / B</span>
            </span>
        );
    }

    renderResetButton() {
        return (
            <button
                onClick={this.props.applyDefaultShortlistRefinement}
                className="ui-btn ui-btn_secondary sales__catalogueRefineReset"
                disabled={isFilteringEmpty(this.props.refinement)}
            >
                <span>Reset</span>
            </button>
        );
    }

    renderLotsFound() {
        return (
            <LotsFound />
        );
    }

    renderTabs() {
        const { active, bpCode, activeTabIndex } = this.state;

        if (!active && ['n', 'xn'].indexOf(bpCode) > -1) {
            return null;
        }

        return (
            <div className="sales__catalogueRefineTabsWrp sales__catalogueRefineTabsWrp_shortlist">
                <Tabs
                    switcherAdditionalChildren={this.renderResetButton()}
                    contentAdditionalChildren={this.renderLotsFound()}
                    activeTabIndex={activeTabIndex}
                    onTabChange={this.handleTabChange}
                >
                    <Tab
                        title="Sale"
                        buttonClassName="sales__catalogueRefineTabSale"
                        disabled={isHorseFiltersTabDisabled(this.props.refinement)}
                    >
                        <SaleFilters />
                    </Tab>
                    <Tab
                        title="Horse"
                        buttonClassName="sales__catalogueRefineTabHorse"
                        disabled={isHorseFiltersTabDisabled(this.props.refinement)}
                    >
                        <HorseFilters />
                    </Tab>
                    <Tab
                        title="Pedigree"
                        buttonClassName="sales__catalogueRefineTabPedigree"
                    >
                        <PedigreeFilters />
                    </Tab>
                    <Tab
                        title={this.renderVendorBuyerTabTitle()}
                        buttonClassName="sales__catalogueRefineTabVendor"
                    >
                        <VendorBuyerFilters />
                    </Tab>
                </Tabs>
            </div>
        );
    }

    renderDatePicker() {
        const { active, bpCode } = this.state;

        if (!active && ['n', 'xn'].indexOf(bpCode) > -1) {
            return null;
        }

        return (
            <div className="sales__searchRefineHeaderWrp">
                <div className="sales__catalogueRefineHeader">
                    Refine Search Results
                </div>
            </div>
        );
    }

    render() {
        const { data: { lotsFound } } = this.props;
        return (
            <div>
                <div className="sales__catalogueRefineWrp">
                    {this.renderRefinementSwitcher()}
                    <div className="sales__catalogueRefineHeader" />
                    {this.renderDatePicker()}
                    {this.renderTabs()}
                </div>
                <div className="sales__HeaderWrp">
                    <div className="sales__Header sales__LotsFound">
                        <h1 className="sales__LotsFoundText">
                            Lots found
                        </h1>
                        <span className="sales__HeaderCounter">
                            <span className="sales__Counter">
                                <span
                                    className="sales__CounterText js-sales-lots-found"
                                    data-test-selector="lots_found_above_table"
                                >
                                    {lotsFound}
                                </span>
                            </span>
                        </span>
                    </div>
                </div>
                <div className="sales__HeaderFilterLabel">
                    <FiltersLabel />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {
        refinement,
        refinementHistory,
        data
    } = state[shortlistStateKey];

    return {
        refinement,
        refinementHistory,
        data
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(shortlistActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ShortlistRefinement);



// WEBPACK FOOTER //
// ./src/js/containers/Shortlist/ShortlistRefinement.js